<script setup>
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  // Only a search can be cleared from here; filters are cleared from the
  // toolbar's own chips.
  showClearSearch: { type: Boolean, default: false },
  copyKey: { type: String, required: true },
});

const emit = defineEmits(['clearSearch']);

const { t } = useI18n();
</script>

<template>
  <div
    data-testid="table-empty-state"
    class="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center rounded-xl outline outline-1 -outline-offset-1 outline-n-container bg-n-solid-2"
  >
    <span class="i-lucide-search size-6 text-n-slate-10" />
    <p class="m-0 text-sm font-medium text-n-slate-12">
      {{ t(`${copyKey}.TOOLBAR.NO_RESULTS_TITLE`) }}
    </p>
    <p class="m-0 text-sm text-n-slate-10">
      {{ t(`${copyKey}.TOOLBAR.NO_RESULTS_BODY`) }}
    </p>
    <NextButton
      v-if="showClearSearch"
      data-testid="table-clear-search"
      :label="t(`${copyKey}.TOOLBAR.CLEAR_SEARCH`)"
      sm
      faded
      slate
      class="mt-2"
      @click="emit('clearSearch')"
    />
  </div>
</template>
